(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvService', function(vv, $rootScope, $http, $q, $location, $window, $timeout, $cacheFactory) {
    var vvService = this;

    vvService.windowLoad = (function() {
      var deferred = $q.defer();
      var loaded = false;
      var onLoaded = function() {
        if (!loaded) {
          loaded = true;
          deferred.resolve();
        }
      };
      return function(func) {
        if (window.document.readyState == 'complete') {
          if (func)
          func();
          onLoaded();
        } else {
          vv.$(window).one('load', function() {
            if (func) {
              $timeout(func, 10);
            }
            onLoaded();
          });
        }
        return deferred.promise;
      }
    })();

    vvService.buildLoginPath = function(action, redirectPath) {
      var params = {};

      if (action && action != 'login')
      params.a = action;

      if (redirectPath == null) {
        if ($location.path() != '/login')
        redirectPath = $location.url();
      }

      if (redirectPath && redirectPath != '/')
      params.p = redirectPath;

      return vv.buildUrl('', '/login', params);
    };

    vvService.shortenUrl = function(url) {
      var region = vv.getVvMetaData('region');
      var gaeApiKey = vv.getVvMetaData('gae:api_key');
      if (region == 'cn') {
        return $http.post('/api/urlshortener/sina', { longUrl: url })
        .then(function(response) {
          console.log('Sina URL shortener response', response.data);
          return response.data.shortUrl;
        }, function(error) {
          console.log('Sina URL shortener error', error.data);
          return url;
        });
      } else if (gaeApiKey) {
        var urlShortener = vv.buildUrl('https://www.googleapis.com', '/urlshortener/v1/url', { key: gaeApiKey });
        return $http.post(urlShortener, { longUrl: url })
        .then(function(response) {
          var data = response.data;
          console.log('Google URL shortener response', data);
          if (data && data.id)
          return data.id;
          else
          return url;
        }, function(error) {
          console.log('Google URL shortener error', error.data);
          return url;
        });
      } else {
        console.log('no shortener');
        return $q.when(url);
      }
    };

    vvService.shortenUrlVV = function(url) {
      return $http.post('/api/shorten', {path: url})
      .then(function(response) {
        return vv.getOrigin().replace(".vonvon.me", ".vonvon.co") + '/' + response.data.shorten;
      });
    };

    vvService.triggerUrl = function(url) {
      var iframe = document.createElement('IFRAME');
      iframe.setAttribute('src', url);
      document.documentElement.appendChild(iframe);
      iframe.parentNode.removeChild(iframe);
      iframe = null;
    };

    vvService.isAutoPublishEnvSvc = function(envSn) {
      var regionList = []; //'dev', 'la', 'br', 'en', 'fr', 'id', 'my', 'ph', 'it', 'tr'];
      return (regionList.indexOf(envSn) >= 0);
    };

    vvService.isSemiAutoPublishEnvSvc = function(envSn) {
      return false;
    };

    var loadQCScriptPromise = null;
    vvService.loadQCScript = function() {
      if (loadQCScriptPromise) {
        return loadQCScriptPromise;
      }
      loadQCScriptPromise = $q(function(resolve, reject) {
        if ($window.QC) {
          resolve();
          return;
        }

        // from: http://qzonestyle.gtimg.cn/qzone/openapi/qc_loader.js
        var version = (function() {
          var ver = "1.0.1";
          try {
            ver = opener.QC.getVersion();
          } catch (e) {}
          return ver ? "-" + ver : ver;
        })();

        var appid = 101336903;
        var redirecturi = vv.getVvMetaData('qq:redirecturi');
        var callback = vv.getVvMetaData('qq:callback');

        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = 'http://qzonestyle.gtimg.cn/qzone/openapi/qc' + version + '.js';
        s.setAttribute("data-appid", appid);
        if (redirecturi) {
          s.setAttribute("data-redirecturi", redirecturi);
        }
        if (callback) {
          s.setAttribute("data-callback", callback);
        }
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.QC) {
              $timeout(function() {
                resolve();
              }, 3000);
            } else {
              reject('qc script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadQCScriptPromise;
    };

    var loadCreateJsPromise = null;
    vvService.loadCreateJs = function() {
      if (loadCreateJsPromise) {
        return loadCreateJsPromise;
      }
      loadCreateJsPromise = $q(function(resolve, reject){
        if ($window.createjs) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = 'https://code.createjs.com/createjs-2015.05.21.min.js';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.createjs) {
              resolve();
            } else {
              reject('createjs script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadCreateJsPromise;
    };

    var loadWordcloudJsPromise = null;
    vvService.loadWordcloudJs = function() {
      if (loadWordcloudJsPromise) {
        return loadWordcloudJsPromise;
      }
      loadWordcloudJsPromise = $q(function(resolve, reject){
        if ($window.WordCloud) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = vv.getVvMetaData('static_root') + '/js/wordcloud2.js?_hv=af320e4';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.WordCloud) {
              resolve();
            } else {
              reject('wordcloud script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadWordcloudJsPromise;
    };

    var loadJCanvasJsPromise = null;
    vvService.loadJCanvasJs = function() {
      if (loadJCanvasJsPromise) {
        return loadJCanvasJsPromise;
      }
      loadJCanvasJsPromise = $q(function(resolve, reject){
        if ($.jCanvas) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = vv.getVvMetaData('static_root') + '/js/jcanvas.min.js?_hv=e1dca94';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($.jCanvas) {
              resolve();
            } else {
              reject('jcanvas script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadJCanvasJsPromise;
    };

    var loadChartJsPromise = null;
    vvService.loadChartJs = function() {
      if (loadChartJsPromise) {
        return loadChartJsPromise;
      }
      loadChartJsPromise = $q(function(resolve, reject){
        if ($window.Chart) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = vv.getVvMetaData('static_root') + '/lib/chart.js/dist/Chart.min.js?_hv=ed13ef4';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.Chart) {
              resolve();
            } else {
              reject('chart.js script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadChartJsPromise;
    };

    var loadWebFontJsPromise = null;
    vvService.loadWebFontJs = function() {
      if (loadWebFontJsPromise) {
        return loadWebFontJsPromise;
      }
      loadWebFontJsPromise = $q(function(resolve, reject){
        if ($window.Chart) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.WebFont) {
              resolve();
            } else {
              reject('webfont.js script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadWebFontJsPromise;
    };

    var loadSwiperJsPromise = null;
    vvService.loadSwiperJs = function() {
      if (loadSwiperJsPromise) {
        return loadSwiperJsPromise;
      }
      loadSwiperJsPromise = $q(function(resolve, reject){
        if ($window.Swiper) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = vv.getVvMetaData('static_root') + '/lib/swiper/dist/js/swiper.min.js';
        var h = document.getElementsByTagName("head");
        if (h && h[0]) {
          h[0].appendChild(s);
          s.onload = function() {
            if ($window.Swiper) {
              resolve();
            } else {
              reject('swiper.min.js script load error');
            }
          }
        } else {
          reject('head not found');
        }
      });
      return loadSwiperJsPromise;
    };

    var httpPostCache = $cacheFactory('httpPostCache');
    vvService.cacheableHttpPost = function(url, data, config) {
      var useCache = config && config['cache'];
      var cacheKey = url + '\r\n';
      if (angular.isString(data))
      cacheKey += data;
      else
      cacheKey += angular.toJson(data);

      var cachedValue = httpPostCache.get(cacheKey);
      if (useCache && cachedValue) {
        return $q.when(cachedValue);
      }

      return $http.post(url, data, config)
      .then(function(response) {
        httpPostCache.put(cacheKey, response);
        return response;
      }, function(error) {
        httpPostCache.remove(cacheKey);
        return $q.reject(error);
      });
    };
  });
})(window, window.angular);
